<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss" rel="stylesheet/scss">
html,body{
  margin: 0;
  height: 100%;
  overflow: auto;
}
#app {
  font-family: Helvetica, Arial, "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color:#fff;
  width: 100%;
  height: 100%;
  .pages{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }
  .page{
    background-color: #f4f4f4;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: auto !important;
    overflow: auto;
  }
}

.el-scrollbar {
  .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue